import styled from 'styled-components';

export const RecordsBox = styled.div`
    display: flex;
    width: 100%;
    overflow: hidden;
    height: 100%;
    & .ant-tabs-tab-btn {
        font-size: 13px;
    }
    & .ant-card-body {
        padding: 0;
        margin: 0;
        flex: 1;
        overflow: hidden;
    }
    & .ant-tabs-content-holder {
        overflow-y: scroll;
    }
    & .ant-tabs-tabpane {
        padding: 0px !important;
    }
    & .ant-table-cell {
        padding: 10px;
    }
    & th.ant-table-cell {
        font-size: 12px;
    }
`;

